import { render } from "./SchoolGardensPage.vue?vue&type=template&id=641bc494"
import script from "./SchoolGardensPage.vue?vue&type=script&lang=js"
export * from "./SchoolGardensPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SchoolGardensPage.vue?vue&type=style&index=0&id=641bc494&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__